import React, { useCallback, useState } from 'react';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import ListItemSkeleton from 'components/Dashboard/ListControl/ListItemSkeleton';
import LegislationUpdateItem from 'components/Dashboard/Legislation/LegislationUpdateItem';

const UPDATES_PAGE_SIZE = 20;

const LegislationRecentUpdatesTab = ({ updates, updatesTotal, isLoading, loadLegislationRecentUpdates, heightContainer }) => {
  const updatesList = updates ?? [];
  const hasMoreUpdates = updatesList.length < updatesTotal;
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const loadMoreUpdates = useCallback(async () => {
    if (!hasMoreUpdates || isLoading || isLoadingMore) {
      return;
    }
    setIsLoadingMore(true);
    try {
      const nextPage = Math.floor(updatesList.length / UPDATES_PAGE_SIZE) + 1;
      await loadLegislationRecentUpdates({ pageNumber: nextPage, pageSize: UPDATES_PAGE_SIZE });
    } finally {
      setIsLoadingMore(false);
    }
  }, [updatesList.length, hasMoreUpdates, isLoading, isLoadingMore, loadLegislationRecentUpdates]);

  const handleScroll = useCallback(
    (scrollValues) => {
      const { scrollTop, scrollHeight, clientHeight } = scrollValues;
      const threshold = 1;
      const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - threshold;
      if (scrolledToBottom) {
        loadMoreUpdates();
      }
    },
    [loadMoreUpdates]
  );

  return (
    <CustomScrollbar
      className={'simple-scrollbar indented-scrollbar-small'}
      style={{ height: `${heightContainer - 70}px` }}
      minimalThumbYSize={55}
      maximalThumbYSize={100}
      onScroll={handleScroll}
    >
      {!isLoading && updatesList.length === 0 ? (
        <p className='mb-0 mt-1 px-3 px-lg-4 pt-3 text-main-blue-65'>No recent updates found</p>
      ) : (
        <ul className='policy-list px-0 items-list pb-2 px-3 px-lg-4 pt-3'>
          {isLoading
            ? Array.from({ length: 3 }).map((_, index) => (
                <ListItemSkeleton key={`legislation-update-skeleton-${index}`} sectionName='KeyUpdates' />
              ))
            : updatesList.map((update) => <LegislationUpdateItem key={update.objectID} update={update} />)}
          {hasMoreUpdates && updatesList.length > 0 && <ListItemSkeleton sectionName='KeyUpdates' />}
        </ul>
      )}
    </CustomScrollbar>
  );
};

export default LegislationRecentUpdatesTab;
